import { smartSchedulingEndpoint } from "../endpoints";

export async function getSmartScheduling(userToken: string) {
  const response = await fetch(`${smartSchedulingEndpoint}/${userToken}`);

  if (!response.ok) {
    return response.json();
  }

  return response.json();
}
